var React = require('react');

function SettingsInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.237 14.063A9.026 9.026 0 0 1 3 12c0-.71.082-1.4.237-2.063L1.474 8.232l2-3.464 2.36.675A8.99 8.99 0 0 1 9.406 3.38L10 1h4l.595 2.38a8.99 8.99 0 0 1 3.57 2.063l2.361-.675 2 3.464-1.763 1.705A9.05 9.05 0 0 1 21 12c0 .71-.082 1.4-.237 2.063l1.763 1.705-2 3.464-2.36-.675a8.99 8.99 0 0 1-3.571 2.063L14 23h-4l-.595-2.38a8.99 8.99 0 0 1-3.57-2.063l-2.361.675-2-3.464 1.763-1.705zM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z","stroke":"currentColor","strokeWidth":"2","fill":"none","strokeLinecap":"square","strokeLinejoin":"round"}));
}

SettingsInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = SettingsInline;

SettingsInline.default = SettingsInline;
